<div class="rss-layout-component-container">
  <div
    class="attribute-editor-component"
    rvSpinner="rss-editor-loader"
    [rvShowSpinner]="spinner"
  >
    <div class="attribute-editor-row">
      <div
        class="form-group has-feedback"
        [ngClass]="{
          'has-error': hasUrlError,
          'has-success': hasValidUrl,
          'has-w3c-validation-errors': hasW3cValidationErrors,
        }"
      >
        <label class="rss-layout-section-heading" for="te-rss-feed"
          >RSS feed link</label
        >
        <div class="rss-feed-url-input">
          <input
            type="text"
            id="te-rss-feed"
            class="form-control u_ellipsis"
            [(ngModel)]="feedUrl"
            placeholder="Enter the link to your RSS feed"
            [disabled]="spinner"
            (debounceEvent)="saveFeed()"
            [attr.aria-invalid]="hasUrlError || null"
            [attr.aria-describedby]="
              hasUrlError || hasW3cValidationErrors
                ? 'te-rss-feed-message'
                : null
            "
          />
          @if (hasUrlError || hasValidUrl) {
            <streamline-icon
              class="overlay-icon form-control-feedback"
              aria-hidden="true"
              name="{{ hasUrlError ? 'exclamation' : 'checkmark' }}"
              width="14"
              height="12"
            ></streamline-icon>
          }
        </div>
        <p
          id="te-rss-feed-message"
          class="help-block"
          [class.rss-w3c-validation-message]="hasW3cValidationErrors"
          aria-live="polite"
        >
          @switch (validationResult) {
            @case ('INVALID_URL') {
              <span
                >Provide a URL to a valid RSS feed. If you need help email
                <a target="_blank" href="mailto:support@risevision.com"
                  >support&#64;risevision.com</a
                ></span
              >
            }
            @case ('UNAUTHORIZED') {
              <span
                >RSS feeds that require authentication are not supported. If you
                need help email
                <a target="_blank" href="mailto:support@risevision.com"
                  >support&#64;risevision.com</a
                ></span
              >
            }
            @case ('NON_FEED') {
              <span
                >Provide a URL to a valid RSS feed. If you need help email
                <a target="_blank" href="mailto:support@risevision.com"
                  >support&#64;risevision.com</a
                >.</span
              >
            }
            @case ('NOT_FOUND') {
              <span
                >Provide a URL to a valid RSS feed. If you need help email
                <a target="_blank" href="mailto:support@risevision.com"
                  >support&#64;risevision.com</a
                >.</span
              >
            }
            @case ('INVALID_FEED') {
              <span
                >The feed you are using contains
                <a
                  [href]="w3cValidationUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  >validation errors</a
                >, which may prevent it from displaying correctly.

                <br /><br />
                If you need help email
                <a target="_blank" href="mailto:support@risevision.com"
                  >support&#64;risevision.com</a
                >.</span
              >
            }
          }
        </p>
      </div>
    </div>

    <div class="attribute-editor-row">
      <div class="form-group">
        <div class="flex-row left-right-aligner">
          <label for="te-rss-max-items">Max items in queue</label>
          <select
            id="te-rss-max-items"
            name="te-rss-max-items"
            class="form-control rss-layout-select"
            [(ngModel)]="maxItems"
            (change)="saveMaxItems()"
            aria-label="Max items in queue"
          >
            <option value="1">1</option>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>
